import React from "react";
import { Box, Button, Typography, Card, CardContent, Grid, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import ShareIcon from "@mui/icons-material/Share";
import SettingsIcon from "@mui/icons-material/Settings";

const stats = [
  { label: "Active", value: "2", subtext: "from 5 created" },
  { label: "Completed", value: "1", subtext: "from 5 created" },
  { label: "Total RSVP", value: "100", subtext: "from 2 events" },
];

const AppLandingPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      {/* Stats Cards */}
      <Grid container spacing={2}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Card sx={{ textAlign: "center", p: 2, boxShadow: 2 }}>
              <CardContent>
                <Typography variant="h6" fontWeight="bold">
                  {stat.label}
                </Typography>
                <Typography variant="h4" fontWeight="bold">
                  {stat.value}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {stat.subtext}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Action Buttons */}
      <Box mt={3} display="flex" alignItems="center" gap={2}>
        <Button variant="contained" color="primary" startIcon={<AddIcon />}>
          Create
        </Button>
        <Button variant="contained" color="info" startIcon={<EditIcon />}> 
          Edit
        </Button>
        <Button variant="contained" color="success" startIcon={<ShareIcon />}>
          Share
        </Button>
        <IconButton color="primary">
          <SettingsIcon />
        </IconButton>
      </Box>

      {/* Event List Table */}
      <Box mt={3}>
        <Typography variant="h5" fontWeight="bold">
          Event List
        </Typography>
      </Box>
    </Box>
  );
};

export default AppLandingPage;